/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { BodyType, ErrorType } from "../../apix-handler";
import type {
  AdminWhatsNewGetV2Params,
  BadRequestResponse,
  ForbiddenResponse,
  WhatsNewAdminPageResponse,
  WhatsNewGetV2Params,
  WhatsNewItemAdminResponse,
  WhatsNewItemSaveRequest,
  WhatsNewLatestResponse,
  WhatsNewPageResponse,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary One page of published announcements, newest published first. Send the previous response's
`nextCursor` to continue.
 */
export const whatsNewGetV2 = (
  params?: WhatsNewGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<WhatsNewPageResponse>(
    { url: `/apix/v2/WhatsNew`, method: "GET", params, signal },
    options,
  );
};

export const getWhatsNewGetV2QueryKey = (params?: WhatsNewGetV2Params) => {
  return [`/apix/v2/WhatsNew`, ...(params ? [params] : [])] as const;
};

export const getWhatsNewGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof whatsNewGetV2>>,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  params?: WhatsNewGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof whatsNewGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWhatsNewGetV2QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof whatsNewGetV2>>> = ({
    signal,
  }) => whatsNewGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof whatsNewGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type WhatsNewGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof whatsNewGetV2>>
>;
export type WhatsNewGetV2QueryError = ErrorType<
  BadRequestResponse | ForbiddenResponse
>;

/**
 * @summary One page of published announcements, newest published first. Send the previous response's
`nextCursor` to continue.
 */

export function useWhatsNewGetV2<
  TData = Awaited<ReturnType<typeof whatsNewGetV2>>,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  params?: WhatsNewGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof whatsNewGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getWhatsNewGetV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary The publish date of the newest announcement, for the nav dot.
 */
export const whatsNewLatestGetV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<WhatsNewLatestResponse>(
    { url: `/apix/v2/WhatsNew/latest`, method: "GET", signal },
    options,
  );
};

export const getWhatsNewLatestGetV2QueryKey = () => {
  return [`/apix/v2/WhatsNew/latest`] as const;
};

export const getWhatsNewLatestGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof whatsNewLatestGetV2>>,
  TError = ErrorType<ForbiddenResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof whatsNewLatestGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWhatsNewLatestGetV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof whatsNewLatestGetV2>>
  > = ({ signal }) => whatsNewLatestGetV2(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof whatsNewLatestGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type WhatsNewLatestGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof whatsNewLatestGetV2>>
>;
export type WhatsNewLatestGetV2QueryError = ErrorType<ForbiddenResponse>;

/**
 * @summary The publish date of the newest announcement, for the nav dot.
 */

export function useWhatsNewLatestGetV2<
  TData = Awaited<ReturnType<typeof whatsNewLatestGetV2>>,
  TError = ErrorType<ForbiddenResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof whatsNewLatestGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getWhatsNewLatestGetV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `draft`
 * @summary One page of announcements in every status, newest created first.
 */
export const adminWhatsNewGetV2 = (
  params?: AdminWhatsNewGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<WhatsNewAdminPageResponse>(
    { url: `/apix/v2/admin/WhatsNew`, method: "GET", params, signal },
    options,
  );
};

export const getAdminWhatsNewGetV2QueryKey = (
  params?: AdminWhatsNewGetV2Params,
) => {
  return [`/apix/v2/admin/WhatsNew`, ...(params ? [params] : [])] as const;
};

export const getAdminWhatsNewGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof adminWhatsNewGetV2>>,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  params?: AdminWhatsNewGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminWhatsNewGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminWhatsNewGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminWhatsNewGetV2>>
  > = ({ signal }) => adminWhatsNewGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminWhatsNewGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminWhatsNewGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof adminWhatsNewGetV2>>
>;
export type AdminWhatsNewGetV2QueryError = ErrorType<
  BadRequestResponse | ForbiddenResponse
>;

/**
 * @summary One page of announcements in every status, newest created first.
 */

export function useAdminWhatsNewGetV2<
  TData = Awaited<ReturnType<typeof adminWhatsNewGetV2>>,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  params?: AdminWhatsNewGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminWhatsNewGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminWhatsNewGetV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `draft`
 * @summary Creates an announcement in the status the author chose. Publishing a new announcement is
this one call - it never lands as a draft first.
 */
export const adminWhatsNewPostV2 = (
  whatsNewItemSaveRequest: BodyType<WhatsNewItemSaveRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<WhatsNewItemAdminResponse>(
    {
      url: `/apix/v2/admin/WhatsNew`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: whatsNewItemSaveRequest,
      signal,
    },
    options,
  );
};

export const getAdminWhatsNewPostV2MutationOptions = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWhatsNewPostV2>>,
    TError,
    { data: BodyType<WhatsNewItemSaveRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWhatsNewPostV2>>,
  TError,
  { data: BodyType<WhatsNewItemSaveRequest> },
  TContext
> => {
  const mutationKey = ["adminWhatsNewPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWhatsNewPostV2>>,
    { data: BodyType<WhatsNewItemSaveRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return adminWhatsNewPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWhatsNewPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWhatsNewPostV2>>
>;
export type AdminWhatsNewPostV2MutationBody = BodyType<WhatsNewItemSaveRequest>;
export type AdminWhatsNewPostV2MutationError = ErrorType<
  BadRequestResponse | ForbiddenResponse
>;

/**
 * @summary Creates an announcement in the status the author chose. Publishing a new announcement is
this one call - it never lands as a draft first.
 */
export const useAdminWhatsNewPostV2 = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWhatsNewPostV2>>,
    TError,
    { data: BodyType<WhatsNewItemSaveRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWhatsNewPostV2>>,
  TError,
  { data: BodyType<WhatsNewItemSaveRequest> },
  TContext
> => {
  const mutationOptions = getAdminWhatsNewPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `draft`
 * @summary Saves content and the target status; publish, move to draft, archive and restore all use
this. Editing a live post keeps its publish date.
 */
export const adminWhatsNewByIdPutV2 = (
  id: string,
  whatsNewItemSaveRequest: BodyType<WhatsNewItemSaveRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<WhatsNewItemAdminResponse>(
    {
      url: `/apix/v2/admin/WhatsNew/${id}`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: whatsNewItemSaveRequest,
    },
    options,
  );
};

export const getAdminWhatsNewByIdPutV2MutationOptions = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWhatsNewByIdPutV2>>,
    TError,
    { id: string; data: BodyType<WhatsNewItemSaveRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWhatsNewByIdPutV2>>,
  TError,
  { id: string; data: BodyType<WhatsNewItemSaveRequest> },
  TContext
> => {
  const mutationKey = ["adminWhatsNewByIdPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWhatsNewByIdPutV2>>,
    { id: string; data: BodyType<WhatsNewItemSaveRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminWhatsNewByIdPutV2(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWhatsNewByIdPutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWhatsNewByIdPutV2>>
>;
export type AdminWhatsNewByIdPutV2MutationBody =
  BodyType<WhatsNewItemSaveRequest>;
export type AdminWhatsNewByIdPutV2MutationError = ErrorType<
  BadRequestResponse | ForbiddenResponse
>;

/**
 * @summary Saves content and the target status; publish, move to draft, archive and restore all use
this. Editing a live post keeps its publish date.
 */
export const useAdminWhatsNewByIdPutV2 = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWhatsNewByIdPutV2>>,
    TError,
    { id: string; data: BodyType<WhatsNewItemSaveRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWhatsNewByIdPutV2>>,
  TError,
  { id: string; data: BodyType<WhatsNewItemSaveRequest> },
  TContext
> => {
  const mutationOptions = getAdminWhatsNewByIdPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `draft`
 * @summary Removes an announcement from the panel and the admin list. Allowed in every status, archived
included. The document is kept, so this stays reversible.
 */
export const adminWhatsNewByIdDeleteV2 = (
  id: string,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    { url: `/apix/v2/admin/WhatsNew/${id}`, method: "DELETE" },
    options,
  );
};

export const getAdminWhatsNewByIdDeleteV2MutationOptions = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWhatsNewByIdDeleteV2>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWhatsNewByIdDeleteV2>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["adminWhatsNewByIdDeleteV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWhatsNewByIdDeleteV2>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminWhatsNewByIdDeleteV2(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWhatsNewByIdDeleteV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWhatsNewByIdDeleteV2>>
>;

export type AdminWhatsNewByIdDeleteV2MutationError = ErrorType<
  BadRequestResponse | ForbiddenResponse
>;

/**
 * @summary Removes an announcement from the panel and the admin list. Allowed in every status, archived
included. The document is kept, so this stays reversible.
 */
export const useAdminWhatsNewByIdDeleteV2 = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWhatsNewByIdDeleteV2>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWhatsNewByIdDeleteV2>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminWhatsNewByIdDeleteV2MutationOptions(options);

  return useMutation(mutationOptions);
};
